import style from '!!raw-loader!./style.css'
import script from '!!raw-loader!./script.js'

export default {
  style,
  script,
}
